/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";

import "./styles.css";

import { SessionProvider } from "./lib/session";
import AppShell from "./components/AppShell";
import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import UsersList from "./pages/UsersList";
import UserDetail from "./pages/UserDetail";
import ChallengesList from "./pages/ChallengesList";
import ChallengeDetail from "./pages/ChallengeDetail";
import Templates from "./pages/Templates";
import OperatorsList from "./pages/OperatorsList";
import OperatorDetail from "./pages/OperatorDetail";
import AuditLog from "./pages/AuditLog";
import EnvironmentHealth from "./pages/EnvironmentHealth";
import FirmCreate from "./pages/FirmCreate";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

render(
  () => (
    <SessionProvider>
      <Router>
        <Route path="/login" component={LoginPage} />
        <Route path="/" component={AppShell}>
          <Route path="/" component={Dashboard} />
          <Route path="/users" component={UsersList} />
          <Route path="/users/:userId" component={UserDetail} />
          <Route path="/challenges" component={ChallengesList} />
          <Route path="/challenges/:instanceId" component={ChallengeDetail} />
          <Route path="/templates" component={Templates} />
          <Route path="/operators" component={OperatorsList} />
          <Route path="/operators/:operatorId" component={OperatorDetail} />
          <Route path="/audit-log" component={AuditLog} />
          <Route path="/environment" component={EnvironmentHealth} />
          <Route path="/firms/new" component={FirmCreate} />
        </Route>
      </Router>
    </SessionProvider>
  ),
  root,
);
